import { api } from 'app/config/apiConfig';
import { Appeal } from '../model/types';
import { Pagination } from 'app/types/common';

interface Params {
  email?: string;
}

export const getUserAppealsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserAppeals: build.query<Pagination<Appeal>, Params>({
      query: (args) => ({
        url: '/appeals',
        params: args,
      }),
    }),
  }),
});

export const { useGetUserAppealsQuery } = getUserAppealsApi;
